import { useGetDatasource } from "hooks/useMasterData";
import styled from "@emotion/styled";
import { Form, FormInstance, Input, Select, Switch } from "antd";
import { FC } from "react";
import { useAppSelector } from "store";

const { Option } = Select;

interface AgentDescriptionFormProps {
  form: FormInstance;
}

const AgentDescriptionForm: FC<AgentDescriptionFormProps> = (form) => {
  const { data: masterDatasource } = useGetDatasource();
  const validatePhoneNumber = (_: any, value: string) => {
    const phoneNumberPattern = /^[0-9]{10}$/;
    if (!value || value.match(phoneNumberPattern)) {
      return Promise.resolve();
    }
    return Promise.reject("โปรดกรอกเบอร์โทรศัพท์ที่ถูกต้อง (10 ตัวอักษร)");
  };

  const childrenDatasource: React.ReactNode[] = [];
  masterDatasource?.map((item) => {
    return childrenDatasource.push(
      <Option key={item.key} value={item.key}>
        {item.name}
      </Option>
    );
  });

  const { contact } = useAppSelector((state) => state.auth);

  return (
    <FormWrapper>
      <FormItems
        labelAlign="left"
        label="ชื่อ"
        name="firstname"
        rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
        
      >
        <Input placeholder="ชื่อ" size="small" autoComplete="off" disabled={contact?.code !== "lunganek"} />
      </FormItems>
      <FormItems
        labelAlign="left"
        label="นามสกุล"
        name="lastname"
        // rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
      >
        <Input placeholder="นามสกุล" size="small" autoComplete="off" disabled={contact?.code !== "lunganek"} />
      </FormItems>
      <>
      <FormItems labelAlign="left" label="ชื่อเรียก" name="alias">
        <Input placeholder="ชื่อเรียก" size="small" autoComplete="off" disabled={contact?.code !== "lunganek"} />
      </FormItems>
      <FormItems
        label="โทรศัพท์มือถือ"
        labelAlign="left"
        name="telephone"
        hidden={true}
        rules={[
          { required: true, message: "กรุณากรอกโทรศัพท์มือถือ" },
          { validator: validatePhoneNumber },
        ]}
      >
        <Input
          placeholder="โทรศัพท์มือถือ"
          size="small"
          autoComplete="off"
          disabled
        />
      </FormItems>
      <FormItems
        label="อีเมล"
        labelAlign="left"
        name="email"
        // rules={[{ required: false, message: "กรุณากรอกอีเมล" }]}
      >
        <Input
          type="email"
          placeholder="อีเมล"
          size="small"
          autoComplete="off"
          disabled={contact?.code !== "lunganek"}
        />
      </FormItems>
      <FormItems label="facebook" labelAlign="left" name="facebook">
        <Input
          type="text"
          placeholder="facebook"
          size="small"
          autoComplete="off"
          disabled={contact?.code !== "lunganek"}
        />
      </FormItems>
      <FormItems
        label="ช่องทางการสมัคร"
        labelAlign="left"
        name="datasource"
        // rules={[{ required: false, message: "กรุณากรอกช่องทางการสมัคร" }]}
      >
        <Select placeholder="ช่องทางการสมัคร" disabled={contact?.code !== "lunganek"}>{childrenDatasource}</Select>
      </FormItems>
      </> 
    </FormWrapper>
  );
};

export default AgentDescriptionForm;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width: 100%;
`;
const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 2px 20px;
  background-color: #ffffffff;
`;
// border-radius: 8px;

const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
